import { LitElement, html } from 'lit';
import styles from './styles';
/**
 * @slot - The element's content.
 *
 * @csspart base - The element's base container.
 */
export default class AmityekoTgCaption extends LitElement {
    render() {
        return html `<p part="base"><slot></slot></p>`;
    }
}
AmityekoTgCaption.styles = styles;
if (!customElements.get('amityeko-tg-caption')) {
    customElements.define('amityeko-tg-caption', AmityekoTgCaption);
}
//# sourceMappingURL=index.js.map